import type { CityConfig } from "../city-template/types";

export const irvineConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Irvine",
  state: "California",
  stateAbbr: "CA",
  slug: "irvine",
  route: "/irvine",
  title: "Emergency Passport Irvine, CA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Irvine, CA — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Orange County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Irvine, CA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport, fast passport renewal, or urgent passport help in Irvine? We help Orange County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Irvine%20California%20cityscape%20at%20golden%20hour%20with%20modern%20suburban%20office%20buildings%2C%20manicured%20green%20landscape%20and%20palm%20trees%2C%20University%20of%20California%20Irvine%20campus%20towers%20visible%2C%20clean%20modern%20planned%20city%20with%20warm%20sunset%20light%2C%20professional%20architectural%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20serene%20and%20modern%20urban%20environment&width=1800&height=700&seq=irvine-hero-001&orientation=landscape",
  heroImageAlt: "Irvine California skyline at golden hour with modern planned city landscape and UC Irvine campus",
  geoPosition: "33.6846;-117.8265",
  geoPlacename: "Irvine, California",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Los Angeles Passport Agency",
    address: "11000 Wilshire Blvd Suite 1000, Los Angeles, CA 90024",
    distance: "Located in West LA — approximately 55–70 minutes from Irvine via I-5 and I-405",
  },
  nearbyCitiesZips: [
    { name: "Irvine", zips: "92602–92604, 92606, 92612, 92614, 92617–92620" },
    { name: "Tustin", zips: "92780, 92782" },
    { name: "Lake Forest", zips: "92630" },
    { name: "Mission Viejo", zips: "92691, 92692" },
    { name: "Newport Beach", zips: "92660, 92661, 92663" },
    { name: "Costa Mesa", zips: "92626, 92627" },
    { name: "Santa Ana", zips: "92701–92707" },
    { name: "Anaheim", zips: "92801–92808" },
    { name: "Orange", zips: "92856, 92861, 92864, 92866, 92867, 92868, 92869" },
    { name: "Laguna Beach", zips: "92651, 92652" },
    { name: "Aliso Viejo", zips: "92653, 92656" },
    { name: "Rancho Santa Margarita", zips: "92688" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Orange County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Los Angeles", route: "/los-angeles" },
    { name: "Fast passport renewal in San Diego", route: "/san-diego" },
    { name: "Emergency passport help in San Francisco", route: "/san-francisco" },
    { name: "Urgent passport services in San Jose", route: "/san-jose" },
    { name: "Same-day passport help in Sacramento", route: "/sacramento" },
    { name: "Passport courier services in Anaheim", route: "/anaheim" },
    { name: "Rush passport help near Santa Ana", route: "/santa-ana" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Irvine from our local office at 200 Spectrum Center Dr. Visit us by appointment, or use our courier pickup throughout Orange County and surrounding areas.",
  fpcOfficeDistance: "200 Spectrum Center Dr — Irvine",
  fpcOfficeAddress: "200 Spectrum Center Dr, Irvine, CA 92618",
  serviceAreaIntro: "From the Irvine Spectrum to the UTC area, from Woodbridge to Northwood — Fast Passport Center serves the entire Irvine community. We regularly help travelers from Tustin, Lake Forest, Mission Viejo, and Newport Beach get their passports fast.",
  nearbyCitiesIntro: "We serve all Irvine neighborhoods and nearby Orange County cities including Tustin, Santa Ana, Anaheim, Costa Mesa, Newport Beach, Mission Viejo, and Laguna Beach. If you are in Orange County, we have you covered.",
  howItWorksIntro: "Most Irvine travelers complete everything online and ship documents overnight. No need to drive to Los Angeles or wait in line at the regional agency.",
  mistakesIntro: "With John Wayne Airport (SNA) serving as Orange County's primary international gateway, Irvine travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Irvine and Orange County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about emergency passports, expedited passports, or fast passport renewal in Irvine? Here are the most common ones we hear from Orange County travelers.",
  statePageRoute: "/states/california",
  statePageName: "California",
  dmvWebsite: "https://www.dmv.ca.gov",
  dmvLabel: "California DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Orange County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "James K.",
      location: "Irvine, CA",
      rating: 5,
      text: "My family trip to Japan was in 3 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Saved our vacation completely.",
      service: "Emergency Passport",
    },
    {
      name: "Michelle T.",
      location: "Tustin, CA",
      rating: 5,
      text: "Needed to renew for a business trip to London. The process was incredibly smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Brian L.",
      location: "Lake Forest, CA",
      rating: 5,
      text: "Lost my passport a week before my honeymoon to Bali. They walked me through the DS-64 process and got me a replacement in 48 hours. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Rachel S.",
      location: "Mission Viejo, CA",
      rating: 5,
      text: "As a frequent international business traveler from Orange County, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "irvine-1",
      name: "Irvine Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15642 Sand Canyon Ave",
      city: "Irvine",
      state: "CA",
      zip: "92618",
      phone: "(949) 753-0398",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Irvine Spectrum",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "irvine-2",
      name: "Tustin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17502 17th St",
      city: "Tustin",
      state: "CA",
      zip: "92780",
      phone: "(714) 544-3834",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2.5 miles from Old Town Tustin",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "irvine-3",
      name: "Santa Ana Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3101 W Sunflower Ave",
      city: "Santa Ana",
      state: "CA",
      zip: "92704",
      phone: "(714) 545-2601",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.2 miles from downtown Santa Ana",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Orange County. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "irvine-4",
      name: "Anaheim Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "701 N Loara St",
      city: "Anaheim",
      state: "CA",
      zip: "92801",
      phone: "(714) 535-2621",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.8 miles from Anaheim City Hall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for northern OC residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "irvine-5",
      name: "Newport Beach Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1860 San Joaquin Hills Rd",
      city: "Newport Beach",
      state: "CA",
      zip: "92660",
      phone: "(949) 644-3249",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.0 miles from Fashion Island",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for coastal OC residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "irvine-6",
      name: "Orange County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "333 W Santa Ana Blvd",
      city: "Santa Ana",
      state: "CA",
      zip: "92701",
      phone: "(714) 834-2500",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.3 miles from Santa Ana City Hall",
      website: "https://www.ocassessor.com/",
      websiteLabel: "OC Clerk-Recorder",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown LA", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Biotech/University Travel", agency: "No biotech or academic expertise", fpc: "UCI, biotech, and tech industry conference travel expertise" },
    { feature: "Multi-Person Processing", agency: "Separate appointments per person", fpc: "Handle families and groups in parallel" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "OC photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Orange County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many OC applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the LA regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many OC families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "OC travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Irvine." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Irvine address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Irvine before international travel?",
      a: "Yes. Fast Passport Center provides emergency passport services in Irvine for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Orange County travelers.",
    },
    {
      q: "How fast can I renew my passport in Irvine?",
      a: "Fast Passport Center offers fast passport renewal in Irvine in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent.",
    },
    {
      q: "What if my passport expires before my cruise?",
      a: "If your passport expires before your cruise, contact Fast Passport Center immediately. Many cruise lines require your passport to be valid for at least 6 months beyond your travel date. We can expedite your passport renewal in Irvine in 24–48 hours so you don't miss your departure.",
    },
    {
      q: "Can I get a same-day passport appointment near Irvine?",
      a: "Same-day passport appointments are only available at the LA Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Irvine residents.",
    },
    {
      q: "Can I expedite a child passport in Irvine?",
      a: "Yes. Fast Passport Center expedites child passports in Irvine for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Orange County families through the entire process.",
    },
    {
      q: "What should I do if I lost my passport before a trip?",
      a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Irvine with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours.",
    },
    {
      q: "How fast can I get a passport in Irvine?",
      a: "With Fast Passport Center's emergency courier service, Irvine travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays.",
    },
    {
      q: "Do I need to drive to the Los Angeles Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Irvine?",
      a: "Popular options include the Irvine Post Office (92618), Tustin Post Office (92780), Santa Ana Main Post Office (92704), and Orange County Clerk (92701). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "Can I get a same-day passport in Irvine?",
      a: "Same-day passports are only available at the LA Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option.",
    },
    {
      q: "What if I live in South Orange County or near the beach?",
      a: "We serve all of Orange County including Laguna Beach, Newport Beach, Dana Point, and San Clemente. Our overnight shipping labels work from any UPS location, so your location within OC doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Irvine?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Irvine?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Irvine and Tustin offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Irvine?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Irvine?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Orange County families through the entire process and help schedule acceptance clerk appointments.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Irvine Spectrum", address: "6600 Irvine Center Dr, Irvine, CA 92618", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Tustin", address: "13222 Jamboree Rd, Tustin, CA 92782", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Irvine", address: "16700 Von Karman Ave, Irvine, CA 92606", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Newport Beach", address: "4101 MacArthur Blvd, Newport Beach, CA 92660", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Santa Ana", address: "3600 W McFadden Ave, Santa Ana, CA 92704", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Costa Mesa", address: "3030 Bristol St, Costa Mesa, CA 92626", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Lake Forest", address: "23612 El Toro Rd, Lake Forest, CA 92630", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — Laguna Niguel", address: "27972 Cabot Rd, Laguna Niguel, CA 92677", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "DMV — Irvine",
      address: "13500 Barranca Pkwy, Irvine, CA 92618",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Santa Ana",
      address: "1330 E First St, Santa Ana, CA 92701",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Laguna Hills",
      address: "23535 El Toro Rd, Lake Forest, CA 92630",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Fullerton",
      address: "2525 W Orangethorpe Ave, Fullerton, CA 92833",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for northern Orange County residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "SNA",
      name: "John Wayne Airport (Orange County)",
      distance: "5 miles from downtown Irvine",
      address: "18601 Airport Way, Santa Ana, CA 92707",
      note: "The primary airport for Orange County. International flights to Mexico, Canada, and connections to Europe and Asia.",
      flightUrl: "https://www.ocair.com/",
      flightLabel: "John Wayne Airport",
      featured: true,
    },
    {
      code: "LAX",
      name: "Los Angeles International Airport",
      distance: "45 miles from Irvine",
      address: "1 World Way, Los Angeles, CA 90045",
      note: "Major international hub for long-haul flights to Asia, Europe, and South America. Accessible via I-405.",
      flightUrl: "https://www.flylax.com/",
      flightLabel: "LAX Flight Info",
      featured: false,
    },
    {
      code: "LGB",
      name: "Long Beach Airport",
      distance: "25 miles from Irvine",
      address: "4100 Donald Douglas Dr, Long Beach, CA 90808",
      note: "Convenient for domestic flights and some international connections. Less crowded than LAX.",
      flightUrl: "https://www.longbeach.gov/lgb/",
      flightLabel: "Long Beach Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the California Department of Public Health Vital Records. Online, mail, or in-person options available for Orange County residents.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through California CDPH Vital Records. Required for estate and legal matters in Orange County.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Orange County Clerk-Recorder. Certified copies available for name changes and legal purposes in Irvine.", url: "https://www.occr.ocgov.com/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Orange County Superior Court. Required for name change passport corrections and legal documentation.", url: "https://www.occourts.org/" },
  ],
};